// extracted by mini-css-extract-plugin
module.exports = {"dot":"Company_dot__7pqN2"};